import { render, staticRenderFns } from "./jump3.vue?vue&type=template&id=f36d3574&scoped=true"
import script from "./jump3.vue?vue&type=script&lang=js"
export * from "./jump3.vue?vue&type=script&lang=js"
import style0 from "./jump3.vue?vue&type=style&index=0&id=f36d3574&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36d3574",
  null
  
)

export default component.exports